export const LIMIT = 10;
export const UPLOAD_CONST = 'https://totalpcscan.com/uploads/upload.php';
export const EMAIL_URL = 'https://totalpcscan.com/uploads/email-send.php';
export const ADMIN_EMAIL = 'zzzz.faiz@gmail.com';
export const FROM_EMAIL = 'info@totalpcscan.com';
